<template>
  <b-modal
    v-model="isModalActive"
    :width="640"
    :can-cancel="false"
    scroll="keep"
  >
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <ProfileCard :player="challenge.player" />
        <p class="modal-card-title">Invitation Received</p>
        <button type="button" class="delete" @click="denyChallenge" />
      </header>
      <section class="modal-card-body is-flex">
        <figure class="image is-48x48">
          <img
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNzcuMTciIGhlaWdodD0iMTc3LjE3IiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiIgaW1hZ2UtcmVuZGVyaW5nPSJvcHRpbWl6ZVF1YWxpdHkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiB2aWV3Qm94PSIwIDAgNTAgNTAiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iMCIgeDE9IjIxLjE5IiB5MT0iMzcuNTUyIiB4Mj0iNzcuNzQiIHkyPSIzNy40MjkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjZmZmIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmIiBzdG9wLW9wYWNpdHk9IjAiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cGF0aCBmaWxsPSIjMWYxYTE3IiBkPSJtMjguNDA4IDkuMjJoNC4yMTZ2LTMuMzk1aDYuNzk2djkuMjk1bC01LjUgNC4yNDN2MTEuODU3bDQuMjIgNC4yMjF2NS4wOGgzLjc4OXY1LjkyOWgtMzMuODU5di01LjkyOWgzLjc5NHYtNS4wOGw0LjI0Ni00LjIyMXYtMTEuODU3bC01LjUwOC00LjI0M3YtOS4yOTVoNi43NzR2My4zOTVoNC4yNDJ2LTMuMzk1aDYuNzl6Ii8+PHBhdGggZmlsbD0idXJsKCMwKSIgZD0ibTI1LjAxIDM1LjA0aC0xMC4yN2wtMS4xNDMgMS4wNjd2MS40MzloMjIuODI2di0xLjQzOWwtMS4xNDMtMS4wNjdoLTEwLjI3bS0xMS40MTMgNS4wOHYyLjUzMmgyMi44MjZ2LTIuNTMyaC0yMi44MjZtMTEuNDEzLTI3LjA4aC0xMi43djEuMTQzbDEuODEyIDEuMzYzaDIxLjgwMmwxLjc2MS0xLjM2M3YtMS4xNDNoLTEyLjY3NW0wIDQuMTkxaC04LjY3OGwxLjQ4MiAxLjE2OHYxLjQxNGgxNC4zOTN2LTEuNDE0bDEuNDgyLTEuMTY4aC04LjY3OG0wIDEzLjU0N2gtNy4xOTd2MS4xNDNsLTEuNDgyIDEuNDM5aDE3LjM1N2wtMS40ODItMS40Mzl2LTEuMTQzaC03LjE5NyIvPjwvc3ZnPg=="
          />
        </figure>
        <div style="width: 100%">
          {{ challenge.player.first_name }}
          {{
            challenge.player.school
              ? " from " + challenge.player.school.school_name
              : ""
          }}
          invited you to {{ challengeName }} game
          <br />
          <small>
            {{ new Date(challenge.createdAt).toLocaleTimeString() }}
          </small>
        </div>
      </section>
      <footer class="modal-card-foot is-flex is-justify-content-space-between">
        <TimerDisplay
          v-if="duration"
          :duration="duration - waitingTime"
          run="true"
        />
        <div class="buttons">
          <b-button label="Decline" @click="denyChallenge" />
          <b-button label="Accept" type="is-primary" @click="acceptChallenge" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";
import TimerDisplay from "@/components/TimerDisplay";
import { CHALLENGE_STATUS, CHALLENGE_TYPE } from "@/constants";

export default {
  components: { ProfileCard, TimerDisplay },

  props: ["challenge", "duration"],

  data() {
    return {
      isModalActive: true,
      waitingTime: null,
      timerInterval: null,
      rtdbTimeOffset: 0,
    };
  },

  watch: {
    challenge: {
      immediate: true,
      handler() {
        console.log("watch challenge", this.challenge);
        if (
          this.challenge &&
          this.challenge.player &&
          this.challenge.status === CHALLENGE_STATUS.SENT
        ) {
          this.isModalActive = true;
          this.startTimer();
        } else {
          this.isModalActive = false;
        }
      },
    },
  },

  computed: {
    challengeName() {
      if (this.challenge.type === CHALLENGE_TYPE.SIMUL) {
        return "his simul";
      } else {
        return `a ${this.challenge.duration / 60}}-minute ${
          this.challenge.variant
        }`;
      }
    },
  },

  methods: {
    denyChallenge() {
      console.log("modal denyChallenge");
      this.stopTimer();
      this.isModalActive = false;
      this.$emit("onDenyChallenge");
    },

    acceptChallenge() {
      console.log("modal acceptChallenge");
      this.stopTimer();
      this.isModalActive = false;
      this.$emit("onAcceptChallenge");
    },

    startTimer() {
      if (!this.challenge) return;
      if (!this.challenge.createdAt) return;
      if (this.timerInterval) return;
      this.timerInterval = setInterval(() => {
        if (!this.challenge || !this.challenge.createdAt) {
          return this.stopTimer();
        }
        this.waitingTime =
          (new Date().getTime() +
            this.rtdbTimeOffset -
            this.challenge.createdAt) /
          1000; // in seconds

        if (this.duration && this.waitingTime > this.duration) {
          this.denyChallenge();
        }
      }, 1000);
    },

    stopTimer() {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
      this.waitingTime = null;
    },
  },

  created() {
    this.rtdbTimeOffset = parseInt(sessionStorage.getItem("rtdbTimeOffset"));
    if (!this.rtdbTimeOffset) this.rtdbTimeOffset = 0;
  },

  beforeDestroy() {
    this.stopTimer();
  },
};
</script>
